import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import SuperSidebar from './SuperSidebar';
import SuperHeader  from './SuperHeader';

const css = `
  .sl-shell { display:flex; height:100vh; background:#f0f2f7; overflow:hidden; }
  .sl-main  { flex:1; display:flex; flex-direction:column; min-width:0; overflow:hidden; }
  .sl-body  { flex:1; overflow-y:auto; overflow-x:hidden; padding:28px 32px; }
  .sl-overlay { display:none; position:fixed; inset:0; background:rgba(0,0,0,.6); z-index:40; }
  @media (max-width:768px) {
    .sl-body { padding:16px; }
    .sl-overlay.open { display:block; }
  }
`;

export default function SuperLayout() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <style>{css}</style>
      <div className="sl-shell">
        <SuperSidebar open={open} onClose={() => setOpen(false)} />
        <div className={`sl-overlay${open?' open':''}`} onClick={() => setOpen(false)} />
        <div className="sl-main">
          <SuperHeader onMenuClick={() => setOpen(true)} />
          <div className="sl-body"><Outlet /></div>
        </div>
      </div>
    </>
  );
}